import React, { useState } from 'react';
import dayjs from 'dayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export default function TimeRangePicker({sendTimeRangeDataFromChild, timeStartInput, timeEndInput, name}) {
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);

    const handleStartTimeChange = (newStartTime) => {
        setStartTime(newStartTime);
        if (endTime && endTime < newStartTime) {
            setEndTime(null);
        }
        sendTimeRangeDataFromChild({"start": newStartTime, "end": endTime, "id": name});
    };
    const handleEndTimeChange = (newEndTime) => {
        setEndTime(newEndTime);
        sendTimeRangeDataFromChild({"start": startTime, "end": newEndTime, "id": name});
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className='flex items-center space-x-4'>
                <TimePicker
                    value={startTime || dayjs(timeStartInput, 'hh:mm A')}
                    onChange={handleStartTimeChange}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    sx={{"& .MuiOutlinedInput-root": { "&:hover > fieldset": { border: '0px solid #F1F1F1'}} }} 
                    className='bg-background-normal focus:outline-none p-4 rounded-lg border border-none'
                />
                <div> - </div>
                <TimePicker
                    value={endTime || dayjs(timeEndInput, 'hh:mm A')}
                    onChange={handleEndTimeChange}
                    disabled={!timeStartInput}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    minTime={startTime}
                    sx={{"& .MuiOutlinedInput-root": { "&:hover > fieldset": { border: '0px solid #F1F1F1'}} }} 
                    className='bg-background-normal focus:outline-none p-4 rounded-lg border border-none'
                />
            </div>
        </LocalizationProvider>
    );
}
